import { STORAGE_KEY, WELCOME_GIFT_KEY } from "../game/constants";

export function isShotMode() {
  if (typeof window === "undefined") return false;
  try {
    return new URLSearchParams(window.location.search).has("asc");
  } catch {
    return false;
  }
}

export const SHOWCASE_SAVE = {
  coins: 2480,
  vehiclesOwned: ["dash", "wasp", "bulldog", "falcon", "magneto", "phantom"],
  equippedVehicle: "phantom",
  stagesOwned: ["neon", "lunar", "ice"],
  equippedStage: "neon",
  removeAds: true,
  starterOwned: true,
  bestByDifficulty: { easy: 2075, medium: 1514, hard: 1823 },
  gamesPlayed: 48,
  runsSinceAd: 0,
  difficulty: "medium",
  playerId: "shot-local-no-cloud",
  playerName: "Courier",
  appleUserId: null,
  welcomeGiftClaimed: true,
  nameChosen: true,
  powerAuto: false,
  ghostOn: true,
  streakCount: 7,
  streakLastDay: "",
  streakClaimedDay: "",
  dailyDay: "",
  dailyProgress: { play3: 2, coins20: 14 },
  dailyClaimed: [],
  ghostByDifficulty: {},
};

/** Playwright injects this before first paint. */
export function writeShowcaseLocalStorage() {
  localStorage.setItem("lanedash.locale", "en");
  localStorage.setItem(WELCOME_GIFT_KEY, "1");
  localStorage.setItem("lanedash.playerName", "Courier");
  localStorage.setItem(STORAGE_KEY, JSON.stringify(SHOWCASE_SAVE));
}
